import { Model as BaseModel } from 'vue-api-query'

export default class Model extends BaseModel {
	static activeControllers = {}

	_currentCancelKey = 'global'

	// Define a base url for a REST API
	baseURL() {
		return ''
	}

	parameterNames() {
		const defaultParams = super.parameterNames()
		const customParams = {
			page: 'page[number]',
			limit: 'page[size]',
		}

		return { ...defaultParams, ...customParams }
	}

	// Implement a default request method

	constructor(...args) {
		super(...args)
		this.fetchOptions = { headers: {} }
	}

	cancelKey(key) {
		this._currentCancelKey = key
		return this
	}

	request(config) {
		// Use the key stored on the instance
		const cancelKey = this._currentCancelKey
		const ModelClass = this.constructor

		if (ModelClass.activeControllers[cancelKey]) {
			ModelClass.activeControllers[cancelKey].abort()
		}

		const currentRequestController = new AbortController()
		ModelClass.activeControllers[cancelKey] = currentRequestController

		const options = {
			...this.fetchOptions,
			signal: currentRequestController.signal,
		}

		return $fetchForApi(config.url, options).finally(() => {
			if (
				ModelClass.activeControllers[cancelKey] ===
				currentRequestController
			) {
				delete ModelClass.activeControllers[cancelKey]
			}
		})
	}

	_setHeaders(headers = {}) {
		if (!this.fetchOptions.headers) {
			this.fetchOptions.headers = {}
		}

		Object.assign(this.fetchOptions.headers, headers)
		return this
	}

	_applyInstance(data, InstanceModel = this.constructor) {
		let apiData = data.data || data
		const apiItem = apiData.item || apiData
		const item = new InstanceModel(apiItem)
		let response = data

		if (this._fromResource) {
			item._from(this._fromResource)
		}

		if (apiData.item) {
			apiData.item = item

			for (const [key, value] of Object.entries(apiData)) {
				if (key !== 'item') {
					response[key] = value
				}
			}
		} else {
			// response = item
			apiData = item
		}

		if (response.data) {
			response.data = apiData
		} else {
			response = apiData
		}

		// return item
		return response
	}

	_applyInstanceCollection(data, model = this.constructor) {
		const apiData = data.data || data

		let collection = apiData.items || apiData
		let response = {}
		collection = Array.isArray(collection) ? collection : [collection]

		collection = collection.map((c) => this._applyInstance(c, model))

		if (apiData.items) {
			response.items = collection

			for (const [key, value] of Object.entries(apiData)) {
				if (key !== 'items') {
					response[key] = value
				}
			}
		} else {
			response = collection
		}

		return response
	}

	toJSON() {
		return { ...this }
	}
}
